import { mergeRatePlans } from "@/helpers/mergeRatePlans.ts";
import { RateGroup } from "@/helpers/types/types.ts";
import { useMemo } from "react";

export const useGetLowestPriceFrom = (rg: RateGroup) => {
  return useMemo(() => {
    const merged = mergeRatePlans(rg);
    const available = merged.filter((rp) => rp.isAvailable);
    if (!available.length) return 0;
    return available.reduce((prev, curr) => (prev.lowestPrice <= curr.lowestPrice ? prev : curr)).lowestPrice;
  }, [rg]);
};
